import { isDevMode } from '@angular/core';
import { ErrorHandler } from '@angular/core';
import { ErrordialogService } from '../cevi-shared/error-dialog/errordialog.service';

export class CustomErrorHandler implements ErrorHandler {

    constructor(private errorDialogService:ErrordialogService ) { }

    handleError(error: any): void {

        if (error.status && error._body) {
            this.errorDialogService.setErrorData(JSON.parse(error._body));
        } else if (error.rejection && error.rejection._body) {
            this.errorDialogService.setErrorData(JSON.parse(error.rejection._body));
        } else {
            if (isDevMode()) {
                console.log(error);
                window.alert('An unexpected error occurred. Check log');
            }
        }
    }
}
